function label(field, validation, rootGetters) {
  return rootGetters['builder/fieldValidation/label'](field, validation.key);
}

function value(validation) {
  if (validation.value === false) {
    return 'false';
  }

  if (validation.value === true) {
    return 'true';
  }

  return validation.value;
}

export default {
  adaptFieldsForTable(field, validations, rootGetters) {
    if (!validations) {
      return [];
    }

    return validations.map((validation) => {
      return {
        id: validation.id,
        label: label(field, validation, rootGetters),
        value: value(validation),
      };
    });
  },
};
